module.exports = __webpack_public_path__ + "img/zhgjn_icon_wxdj_2.png";